import { useEffect, useState } from "react";
export default function Carousel({ BannerImg }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  // เปลี่ยนภาพอัตโนมัติทุก ๆ 5 วินาที
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === BannerImg.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // เปลี่ยนภาพทุก ๆ 5 วินาที
    return () => clearInterval(interval);
  }, [BannerImg.length]);

  const handlePrev = () => {
    setCurrentIndex(
      currentIndex === 0 ? BannerImg.length - 1 : currentIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % BannerImg.length);
  };
  return (
    <>
      <div className="w-full h-full">
        <div className="relative  w-full h-full overflow-hidden">
          <div
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            className="flex transition-transform duration-500 ease-in-out w-full  h-full"
          >
            {BannerImg.map((banner) => (
              <img
                onClick={() =>
                  window.open(
                    !banner.link ? "#!" : banner.link,
                    !banner.link ? "_self" : "_blank"
                  )
                }
                key={banner.id}
                src={banner.status ? banner.img : `Banner ${banner.id}`}
                alt={`Banner ${banner.id}`}
                className=" object-cover cursor-pointer"
              />
            ))}
          </div>
          <button
            onClick={handlePrev}
            className="absolute top-1/2 left-4 transform -translate-y-1/2  hover:bg-white/50 px-4 py-3 rounded-full shadow-lg text-gray-100/0 "
          >
            <i className="fa fa-chevron-left text-[#0F4D81]"></i>
          </button>
          <button
            onClick={handleNext}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 hover:bg-white/50 px-4 py-3 rounded-full shadow-lg text-gray-100/0 "
          >
            <i className="fa fa-chevron-right text-[#0F4D81]"></i>
          </button>
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {BannerImg.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index === currentIndex ? "bg-gray-800" : "bg-gray-400"
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
